import "./_baseGetTag.mjs";
import "./_stringToPath.mjs";
import "./_baseToString.mjs";
import { OTP_CODE_LENGTH as o, REGEXP as i } from "./constants11.mjs";
const p = (t) => t.length <= o, e = (t) => new RegExp(i.isPositiveNumber).test(t), E = (t) => t?.length === o && e(t);
export {
  p as isNotLongerThanOTP,
  E as isOtpCode,
  e as isPositiveNumber
};
//# sourceMappingURL=validators.mjs.map
